import {
  ActivityStatusSchema,
  WorkflowTaskStatusSchema,
} from "@redotech/redo-model/returns/temporal-status";
import { WorkflowTypeSchema } from "@redotech/redo-temporal-common/workflow-types";
import * as z from "zod";

export const getTemporalActivities = {
  name: "getTemporalActivities" as const,
  input: z.object({ workflowType: WorkflowTypeSchema.optional() }),
  output: z.object({
    runningWorkflows: z.array(
      z.object({
        workflowId: z.string(),
        returnId: z.string(),
        teamId: z.string(),
        teamName: z.string(),
        startTime: z.date(),
        nextRetry: z.string().nullish(),
        activityStatuses: z.array(ActivityStatusSchema),
        workflowTaskStatus: WorkflowTaskStatusSchema.nullish(),
        error: z.string().nullish(),
        workflowType: z.string(),
      }),
    ),
    failedWorkflows: z.array(
      z.object({
        workflowId: z.string(),
        returnId: z.string(),
        teamId: z.string(),
        teamName: z.string(),
        startTime: z.date(),
        endTime: z.date().optional(),
        activityStatuses: z.array(ActivityStatusSchema),
        workflowTaskStatus: WorkflowTaskStatusSchema.nullish(),
        error: z.string().nullish(),
        workflowType: z.string(),
      }),
    ),
  }),
};

export type GetTemporalActivitiesOutput = z.infer<
  typeof getTemporalActivities.output
>;

export type RunningWorkflow =
  GetTemporalActivitiesOutput["runningWorkflows"][number];
export type FailedWorkflow =
  GetTemporalActivitiesOutput["failedWorkflows"][number];
